<router-outlet></router-outlet>

<swal #reserveSuccess title="Se ha enviado correctamente!" text="En breve nos pondremos en contacto, muchas gracias!" type="success" icon="success">
</swal>
<swal #reserveError title="Se ha enviado correctamente!" text="En breve nos pondremos en contacto, muchas gracias!" type="error" icon="warning">
</swal>
<swal #reserveInfo title="Se ha enviado correctamente!" text="En breve nos pondremos en contacto, muchas gracias!" type="info" icon="info">
</swal>
<swal #reserveInfoWithouButton title="" text="" type="info" icon="info" [showCancelButton]="false" [showCloseButton]="false" [showConfirmButton]="false">
</swal>